import { render, staticRenderFns } from "./notice_index.vue?vue&type=template&id=093d259c&scoped=true&"
import script from "./notice_index.vue?vue&type=script&lang=ts&"
export * from "./notice_index.vue?vue&type=script&lang=ts&"
import style0 from "./notice_index.vue?vue&type=style&index=0&id=093d259c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d259c",
  null
  
)

export default component.exports